import { TextAlignJustifyIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlignJustify = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextAlignJustifyIcon size={Sizes[size]} {...rest} color={fill} />;
};

AlignJustify.displayName = 'AlignJustify';
